import { faker } from '@faker-js/faker';
import {
  cleanup,
  fireEvent,
  render,
  screen,
  waitFor,
} from '@testing-library/react';
import * as React from 'react';
import { Provider } from 'react-redux';
import { expect } from 'vitest';

import redux from '../../redux';
import BulkPauseUnpauseButton from './index';

function TestComponent() {
  return (
    <Provider store={redux.store}>
      <BulkPauseUnpauseButton />
    </Provider>
  );
}

describe('bulk pause unpause button', () => {
  afterEach(() => {
    cleanup();
  });

  test('bulk pause unpause button', async () => {
    render(<TestComponent />);
    const button = screen.getByText('action.button-text');
    dispatchEvent(
      new CustomEvent('MachineSelectionStatusChanged', {
        detail: [{ id: faker.number.int(), name: faker.string.alphanumeric() }],
      }),
    );
    expect(button).toBeDefined();
    const spy = vi.spyOn(redux.modal, 'open');
    await waitFor(() => expect(button).not.toBeDisabled());
    fireEvent.click(button);
    expect(spy).toHaveBeenCalledTimes(1);
  });
});
